export default "https://assets.egbcdn.net/assets/packs/_/images/svg_icons/app-exchange-no-fill-c39bc3576e7c5ea932ded7861761a729.svg";